import React, { useState } from 'react';

export default function TestShippo() {
  const [rates, setRates] = useState([]);
  const [selectedRateId, setSelectedRateId] = useState(null);

  const getShippingRates = async () => {
    const response = await fetch('https://api-shipping-28612190fdf4.herokuapp.com/shippo/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        address_to: {
          name: 'Customer',
          street1: '123 Main St',
          city: 'San Francisco',
          state: 'CA',
          zip: '94105',
          country: 'US',
          email: 'customer@example.com',
        },
        address_from: {
          name: 'Wear & Wonder Boutique',
          street1: '14915 38th DR SE',
          city: 'Bothell',
          state: 'WA',
          zip: '98012',
          country: 'US',
          email: 'shop@example.com',
        },
        parcel: {
          length: '10',
          width: '7',
          height: '5',
          distance_unit: 'in',
          weight: '2',
          mass_unit: 'lb',
        },
      }),
    });

    const data = await response.json();
    setRates(data);
  };

  const handleRateSelect = (id) => {
    setSelectedRateId(id);
  };

  const selectedRate = rates.find((rate) => rate.object_id === selectedRateId);

  return (
    <div>
      <button onClick={getShippingRates}>Get Rates</button>

      {rates.length > 0 && (
        <div style={{ marginTop: '1rem' }}>
          <h3>Select a Shipping Option:</h3>
          {rates.map((rate) => (
            <label
              key={rate.object_id}
              style={{
                display: 'block',
                border: '1px solid #ccc',
                borderRadius: '8px',
                padding: '1rem',
                marginBottom: '1rem',
                cursor: 'pointer',
                backgroundColor:
                  rate.object_id === selectedRateId ? '#e6f7ff' : '#fff',
              }}
            >
              <input
                type="radio"
                name="shippingRate"
                value={rate.object_id}
                onChange={() => handleRateSelect(rate.object_id)}
                checked={rate.object_id === selectedRateId}
                style={{ marginRight: '10px' }}
              />
              <img
                src={rate.provider_image_75}
                alt={rate.provider}
                style={{ verticalAlign: 'middle' }}
              />
              <div><strong>Provider:</strong> {rate.provider}</div>
              <div><strong>Service:</strong> {rate.servicelevel?.name}</div>
              <div><strong>Cost:</strong> ${rate.amount} {rate.currency}</div>
              <div><strong>Estimated:</strong> {rate.estimated_days} day(s)</div>
              <div><strong>Attributes:</strong> {rate.attributes.join(', ')}</div>
              <div><strong>Terms:</strong> {rate.duration_terms}</div>
            </label>
          ))}
        </div>
      )}

      {selectedRate && (
        <div style={{ marginTop: '1rem', padding: '1rem', border: '2px dashed #4caf50' }}>
          <h4>✅ You selected:</h4>
          <p><strong>{selectedRate.provider}</strong> — {selectedRate.servicelevel?.name}</p>
          <p><strong>${selectedRate.amount} {selectedRate.currency}</strong> - {selectedRate.estimated_days} day(s)</p>
        </div>
      )}
    </div>
  );
}
